import { paths } from "render/routes/paths";

// Manual check-in has no BankID/QR step, so identity is confirmed here, then
// preferred name is collected here too. Active Sessions re-confirms identity
// again unconditionally for every visit, including this one, as its own
// handover check — but preferred name is only ever collected here.
export function getSelectVisitConfirmUrl({
  patientId,
  visitId,
}: {
  patientId: string;
  visitId: string;
}): string {
  const confirmCheckInUrl = paths.selectVisitConfirm.url({
    patientId,
    visitId,
  });

  const preferredNameUrl = `${paths.preferredName.url({
    patientId,
    visitId,
  })}?returnPath=${encodeURIComponent(confirmCheckInUrl)}`;

  return `${paths.identityCheck.url({
    patientId,
    visitId,
  })}?returnPath=${encodeURIComponent(preferredNameUrl)}`;
}
